import * as DialogPrimitive from '@radix-ui/react-dialog';
import styled, { css, keyframes } from 'styled-components';
import { Breakpoints } from '@lmn/design-tokens/themeTokens/commonBreakpoints';
import { higherOrEqualThanBreakpoint, lowerThanBreakpoint } from "../../../themes/mixins/Devices.js";
import { DialogFooter, FooterElementWrapper, StyledPrimaryActionButton, StyledSecondaryActionButton } from "./DialogFooter.js";
import { DialogHeader } from "./DialogHeader.js";
var overlayShow = /*#__PURE__*/keyframes(["from{opacity:0;}to{opacity:1;}"]);
var overlayHide = /*#__PURE__*/keyframes(["from{opacity:1;}to{opacity:0;}"]);
var contentShow = /*#__PURE__*/keyframes(["from{opacity:0;transform:translateY(8px);}to{opacity:1;transform:translateY(0);}"]);
var contentHide = /*#__PURE__*/keyframes(["from{opacity:1;transform:translateY(0);}to{opacity:0;transform:translateY(8px);}"]);
var contentShowDesktop = /*#__PURE__*/keyframes(["from{opacity:0;transform:translate(-50%,-50%) translateY(8px);}to{opacity:1;transform:translate(-50%,-50%) translateY(0);}"]);
var contentHideDesktop = /*#__PURE__*/keyframes(["from{opacity:1;transform:translate(-50%,-50%) translateY(0);}to{opacity:0;transform:translate(-50%,-50%) translateY(8px);}"]);
var transitionDuration = function transitionDuration(disableTransition) {
  return disableTransition ? '0ms' : '150ms';
};
export var Body = /*#__PURE__*/styled.div.withConfig({
  displayName: "Dialogstyles__Body",
  componentId: "sc-1gdff5j-0"
})(["background-color:", ";display:flex;flex-direction:column;flex:1;", ";", ";"], function (_ref) {
  var theme = _ref.theme,
    $bodyBackgroundColor = _ref.$bodyBackgroundColor;
  return $bodyBackgroundColor ? theme.kallisto.color.background.static[$bodyBackgroundColor] : theme.kallisto.color.background.static.backgroundPage;
}, function (props) {
  return props.$stickyHeader && css(["overflow-y:auto;"]);
}, function (props) {
  var _props$$bodyOverflowY;
  return (_props$$bodyOverflowY = props.$bodyOverflowY) !== null && _props$$bodyOverflowY !== void 0 ? _props$$bodyOverflowY : css(["scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}"]);
});
var Header = /*#__PURE__*/styled(DialogHeader).withConfig({
  displayName: "Dialogstyles__Header",
  componentId: "sc-1gdff5j-1"
})([""]);
var Footer = /*#__PURE__*/styled(DialogFooter).withConfig({
  displayName: "Dialogstyles__Footer",
  componentId: "sc-1gdff5j-2"
})([""]);
var FooterStyles = {
  PrimaryButton: StyledPrimaryActionButton,
  SecondaryButton: StyledSecondaryActionButton,
  AdditionalElement: FooterElementWrapper
};
var Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "Dialogstyles__Content",
  componentId: "sc-1gdff5j-3"
})(["position:relative;z-index:0;flex:1;", ";", ";", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.kallisto.mixins.font('Body');
}, function (_ref3) {
  var theme = _ref3.theme,
    $defaultBodyPadding = _ref3.$defaultBodyPadding;
  return theme.kallisto.mixins.padding($defaultBodyPadding !== null && $defaultBodyPadding !== void 0 ? $defaultBodyPadding : 'space200');
}, function (_ref4) {
  var theme = _ref4.theme,
    $bodyPaddingXS = _ref4.$bodyPaddingXS;
  return lowerThanBreakpoint(Breakpoints['breakpoints-xs'], css(["", ""], theme.kallisto.mixins.padding($bodyPaddingXS !== null && $bodyPaddingXS !== void 0 ? $bodyPaddingXS : 'space100')));
}, function (_ref5) {
  var theme = _ref5.theme,
    $bodyPaddingS = _ref5.$bodyPaddingS;
  return lowerThanBreakpoint(Breakpoints['breakpoints-s'], css(["", ""], theme.kallisto.mixins.padding($bodyPaddingS !== null && $bodyPaddingS !== void 0 ? $bodyPaddingS : 'space300')));
});
export var Overlay = /*#__PURE__*/styled(DialogPrimitive.Overlay).withConfig({
  displayName: "Dialogstyles__Overlay",
  componentId: "sc-1gdff5j-4"
})(["position:fixed;inset:0;background:", ";z-index:1300;&[data-state='open']{animation:", " ", " ease-out;}&[data-state='closed']{animation:", " ", " ease-in;}"], function (p) {
  return p.$transparent ? 'transparent' : 'rgba(0 0 0 / 0.5)';
}, overlayShow, function (p) {
  return transitionDuration(p.$disableTransition);
}, overlayHide, function (p) {
  return transitionDuration(p.$disableTransition);
});
var PaperStyled = /*#__PURE__*/styled(DialogPrimitive.Content).withConfig({
  displayName: "Dialogstyles__PaperStyled",
  componentId: "sc-1gdff5j-5"
})(["", " background:", ";margin:0;width:100%;max-width:100%;color:", ";outline:none;position:fixed;left:0;right:0;bottom:0;display:flex;flex-direction:column;z-index:1400;", " &[data-state='open']{animation-name:", ";animation-duration:", ";animation-timing-function:ease-out;}&[data-state='closed']{animation-name:", ";animation-duration:", ";animation-timing-function:ease-in;}", " ", ";", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.kallisto.shadow.largeTopShadow;
}, function (p) {
  return p.theme.kallisto.color.background.static.backgroundPage;
}, function (p) {
  return p.theme.kallisto.color.text.static.textPrimary;
}, function (_ref7) {
  var theme = _ref7.theme,
    $fullScreen = _ref7.$fullScreen,
    $fullHeight = _ref7.$fullHeight;
  return $fullScreen ? css(["top:0;bottom:0;height:100%;border-radius:0;"]) : css(["", ";border-radius:", ";", ""], $fullHeight && 'max-height: none', "".concat(theme.kallisto.border.radius.radius200, " ").concat(theme.kallisto.border.radius.radius200, " 0 0"), $fullHeight ? css(["height:calc(100% - ", ");"], theme.kallisto.space.space400) : css(["max-height:calc(100% - ", ");"], theme.kallisto.space.space400));
}, contentShow, function (p) {
  return transitionDuration(p.$disableTransition);
}, contentHide, function (p) {
  return transitionDuration(p.$disableTransition);
}, function (p) {
  return !p.$fullScreen && higherOrEqualThanBreakpoint(Breakpoints['breakpoints-s'], css(["left:50%;right:auto;bottom:auto;top:50%;transform:translate(-50%,-50%);border-radius:", ";max-height:calc(100% - ", ");max-width:743px;width:calc(100% - ", ");&[data-state='open']{animation-name:", ";}&[data-state='closed']{animation-name:", ";}"], function (_ref8) {
    var theme = _ref8.theme;
    return theme.kallisto.border.radius.radius200;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.kallisto.mixins.spacing('space800');
  }, function (_ref0) {
    var theme = _ref0.theme;
    return theme.kallisto.mixins.spacing('space800');
  }, contentShowDesktop, contentHideDesktop));
}, function (p) {
  return p.$stickyHeader ? css(["overflow-y:hidden;"]) : css(["overflow-y:auto;"]);
}, function (props) {
  var _props$$bodyOverflowY2;
  return (_props$$bodyOverflowY2 = props.$bodyOverflowY) !== null && _props$$bodyOverflowY2 !== void 0 ? _props$$bodyOverflowY2 : css(["scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}"]);
});
export var DialogStyles = {
  Body: Body,
  Content: Content,
  Paper: PaperStyled,
  Overlay: Overlay,
  Header: Header,
  Footer: Footer,
  FooterStyles: FooterStyles
};